import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ResponsableTourismComponent } from '@responsable-tourism/components/PE/responsable-tourism.component';

export const responsableTourismRootRoute = 'responsable-tourism';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ResponsableTourismComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class ResponsableTourismRoutingModule { }
